export default __webpack_public_path__ + "static/media/Covered Strangle.7045de31.svg";